// extracted by mini-css-extract-plugin
export default {"SmsView":"kllRZreg","actionContent":"bcadEXXK","withSms":"j1P89kwb","img":"KthNE4QU","buttonBox":"YjKt3T8U"};
    if(module.hot) {
      // 1712151480779
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  